/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
// import { useHistory } from 'react-router-dom';
// import GoBackIcon from '../../svgs/GoBackIcon';
import NewTableFilters from '../FilterComponents/NewTableFilters';
// import TableFilters from '../FilterInputs/TableFilters';
import SearchBox from '../SearchBox';
import StyledButton from '../StyledButton';
import Styles from './DashboardHeader.module.scss';

type Props = {
  title?: any;
  smallSubTitle?: string;
  searchPlaceholder?: string;
  filterObj?: any;
  exportObj?: any;
  children?:any
  subtitle?: any;
  hasButton?:boolean;
  handleButtonAction?:any;
  buttonTitle?:string;
  width?:string;
  buttonIcon?:any;
  search?: string;
  onSearchChange?:any;
  searchLoading?: boolean;
  specialClass?:string;
  hideButtonClass?:string;
  isDashboardChildren?:any;
  columnObject?:any;
  hasBackButton?:boolean;
  disableExport?:boolean;
  disableSearch?:boolean;
  disbleFilter?:boolean;
  payload?: any;
  refetch?: any;
  hasAlternativeDate?:boolean;
  hasContainerClass?:any;
}

const DashboardHeader = ({
  // title,
  // smallSubTitle,
  searchPlaceholder,
  exportObj,
  children,
  // subtitle,
  search,
  onSearchChange,
  // searchLoading,
  filterObj,
  columnObject,
  // hasBackButton,
  hasButton,
  disableExport,
  disableSearch,
  disbleFilter,
  handleButtonAction,
  hasAlternativeDate,
  hasContainerClass,
  buttonTitle,
  buttonIcon,
}: Props) =>
  // const name = '';
  // eslint-disable-next-line implicit-arrow-linebreak
  // const { goBack } = useHistory();
  (
    <div className={Styles.wrapper}>

      <div className={children ? '' : hasContainerClass || Styles.wrapper__searchAndTabContainer}>
        <div className={Styles.wrapper__searchContainer}>
          {searchPlaceholder && (
          <div>
            <span className={Styles.wrapper__searchTag}>Search here</span>
            <SearchBox disabled={disableSearch} loading={false} name="search" placeholder={searchPlaceholder} value={search} handleChange={onSearchChange || (() => {})} />
          </div>
          )}
        </div>

        <div className={Styles.wrapper__tabAndExportFilter}>
          <div className={Styles.wrapper__tabContainer}>
            {children}

          </div>
          <div className={Styles.wrapper__exportAndFilter}>
            <NewTableFilters
              filterObj={filterObj}
              exportObj={exportObj}
              columnObject={columnObject}
              disableExport={disableExport}
              disbleFilter={disbleFilter}
              hasAlternativeDate={hasAlternativeDate}
            />
            {
              hasButton && <div><StyledButton name={buttonTitle} border="none" padding="10px 16px" borderRadius="4px" backgroundColor="#5941A9" color="white" fontSize="14px" icon={buttonIcon} onClick={handleButtonAction} /></div>
            }

          </div>
        </div>
      </div>
    </div>

  );
export default DashboardHeader;
